import { readCookie } from './read-write-cookies';

export function loadFavouriteCookies() {
    let favouriteCookies = {};

    try {
        favouriteCookies = JSON.parse(readCookie('favourite-displays') ?? '[]');
        if (!Array.isArray(favouriteCookies)) {
            favouriteCookies = [];
        }
    } catch (err) {
        favouriteCookies = [];
    }

    return favouriteCookies;
}
